<template><div><h2>Alert</h2>
<ul>
<li>[feature] 添加属性 prop:content</li>
</ul>
<h2>Cell</h2>
<ul>
<li>[feature] 支持 prop:is-loading 显示加载图标，适用于异步加载数据的场景</li>
</ul>
<h2>Datetime</h2>
<ul>
<li>[fix] 在 nextTick 回调渲染 picker 避免赋值报错 #1180</li>
</ul>
<h2>Scroller</h2>
<ul>
<li>[fix] 修复 resize 事件没有移除导致切换页面报错 #1183</li>
<li>[fix] 修复滚动情况下跳转页面报错 #1187</li>
</ul>
<h2>Swipeout</h2>
<ul>
<li>[fix] 修复disabled时不能上下滚动问题</li>
<li>[fix] 修复disabled时，安卓手机上不能触发点击事件的问题</li>
</ul>
<h2>XIcon</h2>
<ul>
<li>[enhance] 支持传任意属性 #1147</li>
</ul>
</div></template><script>
export default {
  head: {"title":" | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// next_zh-CN-279.vue?8f8f89a6